<template>
<div class="modal-content">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>